import React from 'react';
import { PageHeader } from 'antd';
import { createUseStyles } from 'react-jss';
import { useParams } from 'react-router-dom-v5-compat';
import type { SimulationDetail } from '../../store/simulation/types';
import { SimulationProgress } from './SimulationProgress';
import { SimulationActionDropdown } from '../../components/simulation/shared/SimulationActionDropdown';

const useStyles = createUseStyles({
  header: {
    padding: 0,
  },
});

export interface SimulationPageHeaderProps {
  simulation: SimulationDetail;
}

export const SimulationPageHeader = ({ simulation }: SimulationPageHeaderProps) => {
  const classes = useStyles();
  const params = useParams<{ profileId: string; tabId: string; subTabId?: string }>();
  let title: string | React.ReactNode = simulation.name;
  let subTitle = 'Detail';

  if (params.tabId === 'mappings') {
    title = simulation.name;
    subTitle = 'Context Mappings';
  }

  if (params.tabId === 'shipments') {
    title = simulation.name;
    subTitle = 'Shipments';
  }

  if (params.tabId === 'export') {
    title = simulation.name;
    subTitle = 'Export';
  }

  if (params.tabId === 'carrier_selection_report') {
    title = simulation.name;
    subTitle = 'Carrier Selection Report';
  }

  if (params.tabId === 'tnt_reports') {
    title = simulation.name;
    subTitle = 'Time in Transit Report';
  }
  return (
    <>
      <PageHeader
        className={classes.header}
        title={title}
        subTitle={subTitle}
        extra={<SimulationActionDropdown simulation={simulation} />}
      />
      <SimulationProgress simulation={simulation} />
    </>
  );
};
